import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const EditFooter = () => {
  const { id } = useParams();
  const navigate = useNavigate();
const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const [formData, setFormData] = useState({
    title: "",
    get_link: "",
    image: null,
    preview: "",
  });

  const [loading, setLoading] = useState(true);

  // Fetch existing footer data
  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/footers/${id}`);
await axios.post(`${baseUrl}/footers/update/${id}`, data, { headers: { "Content-Type": "multipart/form-data" } });

        const data = res.data || {};
        setFormData({
          title: data.title || "",
          get_link: data.get_link || "",
          preview: data.image || "",
          image: null,
        });
      } catch (err) {
        console.error(err);
        alert("Failed to load footer details!");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchFooterData();
  }, [id]);

  // Handle text input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
        preview: URL.createObjectURL(file),
      }));
    }
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("get_link", formData.get_link);
      if (formData.image) data.append("image", formData.image);

      const res = await axios.post(`/api/footer/update/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.status === 200) {
        alert("Footer updated successfully!");
        navigate("/footer");
      } else {
        alert("Update failed, please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  if (loading) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="main-container container-fluid p-5">
      <div className="page-header mb-4">
        <h1 className="page-title text-xl font-semibold mb-2">Update Footer Section</h1>
        <ol className="breadcrumb text-sm">
          <li className="breadcrumb-item">
            <a href="/footer" className="text-primary">Home</a>
          </li>
          <li className="breadcrumb-item active text-gray-600">Footer</li>
        </ol>
      </div>

      <form onSubmit={handleSubmit} className="card p-4 shadow-sm border rounded-xl">
        {/* Title */}
        <div className="mb-4">
          <label className="form-label font-medium">Title</label>
          <input
            type="text"
            className="form-control border rounded-md p-2 w-full"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        {/* Image Dropify-style */}
        <div className="mb-5">
          <label className="form-label font-medium">Image</label>
          <div
            className="border-2 border-dashed rounded-xl w-[250px] h-[200px] flex flex-col items-center justify-center cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50"
            onClick={() => document.getElementById("footer-image").click()}
          >
            <input
              type="file"
              id="footer-image"
              className="hidden"
              accept="image/*"
              onChange={handleFileChange}
            />
            {formData.preview ? (
              <img
                src={formData.preview}
                alt="Preview"
                className="w-full h-full object-cover rounded-xl"
              />
            ) : (
              <p className="text-gray-500 text-center">
                Drag & drop an image here or click
              </p>
            )}
          </div>
          <p className="text-sm text-gray-500 mt-2">Recommended Size: 700px × 700px</p>
        </div>

        {/* Get Link */}
        <div className="mb-4">
          <label className="form-label font-medium">Get Link</label>
          <input
            type="text"
            className="form-control border rounded-md p-2 w-full"
            name="get_link"
            value={formData.get_link}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
          Update
        </button>
      </form>
    </div>
  );
};

export default EditFooter;

